/* Capini mega-menu controller — instant show/hide, no overlap.
   Moved from inline snippet to external asset to avoid <script> being
   rendered as text when the snippet renders N times in one page. */
(function () {
  if (window.__capiniMegaInit) return;
  window.__capiniMegaInit = true;

  function patchProto() {
    if (window.__capiniMegaProtoPatched) return true;
    var any = document.querySelector('details[is="mega-menu-disclosure"]');
    if (!any) return false;
    var proto = Object.getPrototypeOf(any);
    if (!proto || !proto._transitionIn) return false;
    window.__capiniMegaProtoPatched = true;
    proto._transitionIn = function () {
      var self = this;
      document.querySelectorAll('details[is="mega-menu-disclosure"][open]').forEach(function (d) {
        if (d !== self) {
          d.removeAttribute('open');
          var c = d.querySelector('.mega-menu, mega-menu');
          if (c) c.style.display = 'none';
        }
      });
      this.contentElement.style.display = 'flex';
      this.contentElement.style.opacity = '1';
      return Promise.resolve();
    };
    proto._transitionOut = function () {
      this.contentElement.style.display = 'none';
      return Promise.resolve();
    };
    return true;
  }

  function attachObservers() {
    document.querySelectorAll('details[is="mega-menu-disclosure"]').forEach(function (d) {
      if (d.dataset.capSync) return;
      d.dataset.capSync = '1';
      function sync() {
        var content = d.querySelector('.mega-menu, mega-menu');
        if (!content) return;
        content.style.display = d.hasAttribute('open') ? 'flex' : 'none';
        content.style.opacity = '1';
      }
      sync();
      new MutationObserver(sync).observe(d, { attributes: true, attributeFilter: ['open'] });
    });
  }

  function bindSidebarMenus() {
    document.querySelectorAll('.mega-menu--sidebar').forEach(function (menu) {
      if (menu.dataset.bound) return;
      menu.dataset.bound = '1';
      var cats = menu.querySelectorAll('.mega-menu-sidebar__category-item');
      var subs = menu.querySelectorAll('.mega-menu-sidebar__submenu');
      var promos = menu.querySelectorAll('.mega-menu-sidebar__promo-item');
      function activate(i) {
        cats.forEach(function (c, j) { c.classList.toggle('is-active', i === j); });
        subs.forEach(function (s, j) { s.classList.toggle('is-active', i === j); s.hidden = i !== j; });
        promos.forEach(function (p, j) { p.classList.toggle('is-active', i === j); p.hidden = i !== j; });
      }
      cats.forEach(function (cat, i) {
        cat.addEventListener('mouseenter', function () { activate(i); });
        var btn = cat.querySelector('.mega-menu-sidebar__category-button');
        if (btn) btn.addEventListener('focus', function () { activate(i); });
      });
    });
  }

  function tick() {
    patchProto();
    attachObservers();
    bindSidebarMenus();
  }

  tick();
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', tick);
  }

  // Retry for up to 5s — covers custom-element upgrade race
  var tries = 0;
  var poll = setInterval(function () {
    tick();
    if (window.__capiniMegaProtoPatched || ++tries > 100) clearInterval(poll);
  }, 50);
})();
